module.exports = __webpack_public_path__ + "img/bootstrap.d0a60231.svg";